var o = {
  radio: {
    borderWidth: {
      value: "{components.radio.button.borderWidth}"
    },
    borderColor: {
      value: "{components.radio.button.borderColor}"
    },
    backgroundColor: {
      value: "{components.radio.button.backgroundColor}"
    },
    _checked: {
      color: {
        value: "{components.radio.button._checked.color}"
      }
    },
    label: {
      color: {
        value: "{components.radio.label.color}"
      }
    }
  },
  label: {
    color: {
      value: "{components.field.label.color}"
    }
  }
};
export { o as radiogroup };